// @flow

import type { Plan } from '@zapier/common-utils';

/*
   Mark third lowest paid plan as recommended (which is typically the second lowest
   after the free plan). But, skip it if they are on that plan or a higher value plan.
   We don't want to encourage them to downgrade!

   Expects sortedPlans to be sorted by billing amount, ascending.
*/
export default (
  sortedPlans: Array<Plan>,
  currentPlanIndex: number
): Array<Plan> => {
  if (sortedPlans.length > 2 && currentPlanIndex < 2) {
    return sortedPlans.map((plan, i) =>
      i === 2
        ? {
            ...plan,
            isRecommended: true,
          }
        : plan
    );
  }

  return sortedPlans;
};
